import React, { useEffect, useState } from "react";
import { Button, Input, Row, Space, Spin, Tabs } from "antd";
import { FONT, isAdmin, ROLE_ADMIN, ROLE_USER } from "constants/index";

import { getUsers } from "services/user/user-service";
import UsersClient from "./users-admin";
import { ArrowRight, Search } from "lucide-react";
import { notificationErroInternal } from "util/api-utils";

const UsersAdminTab = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(null);

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoading(true);
    getData();
  }

  async function getData() {
    let obj = {
      search: search,
    };

    if (search == null || search == "") {
      obj = {};
    }
    try {
      const res = await getUsers(obj);
      setData(res);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Row gutter={24} style={{ padding: "10px" }}>
        <Space>
          <Input
            placeholder="Pesquisar Usuário"
            onChange={(value) => setSearch(value.target.value)}
            suffix={<Search size={18} color="#e0e0e0" />}
            style={{ height: "40px" }}
            onPressEnter={refreshData}
          />

          <Button
            style={{ fontFamily: FONT }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Space>
      </Row>
      <Spin spinning={loading}>
        <Tabs
          defaultActiveKey="1"
          centered
          size="large"
          style={{ fontFamily: FONT }}
          items={[
            ...(isAdmin()
              ? [
                  {
                    label: "Administradores",
                    key: ROLE_ADMIN,
                    children: (
                      <UsersClient
                        users={data.filter((item) => item.role === ROLE_ADMIN)}
                        refreshData={refreshData}
                      />
                    ),
                  },
                ]
              : []),

            {
              label: `Clientes`,
              key: ROLE_USER,
              children: (
                <UsersClient
                  users={data.filter((item) => item.role == ROLE_USER)}
                  refreshData={refreshData}
                />
              ),
            },
            ,
          ]}
        />
      </Spin>
    </>
  );
};
export default UsersAdminTab;
